(
    function (skyward, $, undefined)
    {
        skyward.rolemodulepath = skyward.rolemodulepath || {};

        var init = function (selector)
        {
            var modulePathGrids = $('#RoleModulePaths_grid, #EmployeeAccessRoleModulePaths_grid, #TeacherAccessRoleModulePaths_grid, #FamilyAccessRoleModulePaths_grid , #StudentAccessRoleModulePaths_grid, #ActivityAccessRoleModulePaths_grid, #NewStudentEnrollmentRoleModulePaths_grid, #DataMigrationManagerRoleModulePaths_grid, #StudentServicesRoleModulePaths_grid, #SMSToQmlativToolsRoleModulePaths_grid');
            var layer;

            modulePathGrids.off("click").on("click", ".hierarchyButton", skyward.hierarchy.toggle);

            var toggleViaAjax = function (cb, inputData, urlExtenstion)
            {
                $.ajax(skyward.global.virtualDir + urlExtenstion,
                    {
                        type: "POST",
                        dataType: "JSON",
                        context: { row: cb.parent().parent() },
                        data: { json: JSON.stringify(inputData.moduleStatus) },
                        success: function (data)
                        {
                            cb.data("bound", "False");
                            if (data != null)
                            {
                                // the server will return a dictionary of how all of the checkboxes in the module
                                // should display their value as (e.g. checked, unchecked, indeterminate)
                                modulePathGrids.find("[data-module='" + inputData.moduleData.module + "']").each(function ()
                                {
                                    var currentCB = $(this);
                                    var obj = currentCB.data("object");
                                    var screen = currentCB.data("screen");
                                    var operation = currentCB.data("operation");
                                    var modulePath = inputData.moduleData.module;

                                    if (obj != null)
                                    {
                                        modulePath += "/" + obj;
                                    }
                                    if (screen != null)
                                    {
                                        modulePath += "/" + screen;
                                    }

                                    if (modulePath in data.MenuStatus && operation in data.MenuStatus[modulePath])
                                    {
                                        currentCB.prop("checked", data.MenuStatus[modulePath][operation] == "checked");
                                        currentCB.data("checked", data.MenuStatus[modulePath][operation] == "checked" ? "True" : "False");
                                        currentCB.prop("indeterminate", data.MenuStatus[modulePath][operation] == "partial");
                                        currentCB.data("indeterminate", data.MenuStatus[modulePath][operation] == "partial" ? "True" : "False");
                                    }
                                });
                            }
                            layer.close();
                        },
                        error: function (data)
                        {
                            layer.close();
                        }
                    });
            };

            // screen level checkbox
            modulePathGrids.on('click', 'input.rolemodulepath-check', null, function (event)
            {
                var cb = $(this);
                var data = getCheckboxData(cb);

                // for non-tri-state checkboxes get the status directly from the box
                data.moduleData.checked = this.checked;
                var urlExtension = "Security/AdvancedSecurity/ToggleScreen/" + data.moduleData.roleId + "/" + data.moduleData.modulePath + "/" +
                    data.moduleData.field + "/" + data.moduleData.checked + "/" + data.moduleData.portal;

                findOpenScreensForModule(cb, data, urlExtension);
            });

            // object level checkbox
            modulePathGrids.on('click', 'input.objectCheckbox', null, function (event)
            {
                var cb = $(this);
                var data = getCheckboxData(cb);
                var urlExtension = "Security/AdvancedSecurity/ToggleObject/" + data.moduleData.roleId + "/" +
                    data.moduleData.module + "/" + data.moduleData.object + "/" + data.moduleData.operation + "/" + data.moduleData.checked + "/" + data.moduleData.portal;

                findOpenScreensForModule(cb, data, urlExtension);
            });

            //module level checkbox
            modulePathGrids.on('click', 'input.moduleCheckbox', null, function (event)
            {
                var cb = $(this);
                var data = getCheckboxData(cb);
                var urlExtension = "Security/AdvancedSecurity/ToggleModule/" + data.moduleData.roleId + "/" +
                    data.moduleData.module + "/" + data.moduleData.operation + "/" + data.moduleData.checked + "/" + data.moduleData.portal;

                findOpenScreensForModule(cb, data, urlExtension);
            });

            // read the data attributes set from RoleModulePathController
            var getCheckboxData = function (cb)
            {
                var data = { moduleData: {}, moduleStatus: {} };
                data.moduleData.module = cb.data("module");
                data.moduleData.object = cb.data("object");
                data.moduleData.screen = cb.data("screen");
                data.moduleData.roleId = cb.data("roleId");
                data.moduleData.modulePath = cb.data("modulePath");
                data.moduleData.operation = cb.data("operation");
                data.moduleData.field = cb.data("field");
                data.moduleData.checked = cb.data("indeterminate") == "True" || cb.data("checked") == "False";
                data.moduleData.portal = cb.data("portal");
                return data;
            };

            // on page load go through all module level checkboxes and object level checkboxes
            // to set them to either indeterminate (square) or checked
            $(selector + " .moduleCheckbox, " + selector + " .objectCheckbox").each(function ()
            {
                var cb = $(this);
                if (cb.data("indeterminate") == "True")
                {
                    cb.prop("indeterminate", true);
                }
                else if (cb.data("checked") == "True")
                {
                    cb.prop("checked", true);
                }
            });

            var findOpenScreensForModule = function (cb, data, urlExtention)
            {

                // because the dom is changing during this, set an attribute when a click event
                // has been fired off and only do processing if the flag isn't set
                var bound = cb.data("bound");
                if (bound != "True")
                {
                    layer = skyward.modalLayer.newModalLayer(null, null, {
                        closeOnClick: false,
                        closeOnRecordSelected: false,
                        closeOnEscape: false
                    });

                    cb.data("bound", "True");

                    // clicking a checkbox can never make it indeterminate
                    cb.data("indeterminate", "False");
                    // checked attribute used because of issues in IE
                    cb.data("checked", data.moduleData.checked ? "True" : "False");
                    cb.prop("indeterminate", false);
                    cb.prop("checked", data.moduleData.checked);
                    cb.data("bound", "True");

                    // roll through all checkboxes that have the same module as the one checked. This includes
                    // all module, object, and screen checkboxes for that module. Build up a dictionary of how
                    // all of these checkboxes are currently displayed so the server can determine what will change
                    modulePathGrids.find("[data-module='" + cb.data('module') + "']").each(function ()
                    {
                        var currentCB = $(this);
                        var checkStyle;
                        // module level checkbox
                        if (currentCB.data('parent') == "Module")
                        {
                            checkStyle = currentCB.data("indeterminate") == "True" ? "partial" : this.checked ? "checked" : "unchecked";
                            if (!(currentCB.data('module') in data.moduleStatus))
                            {
                                data.moduleStatus[currentCB.data('module')] = {};
                            }
                            data.moduleStatus[currentCB.data('module')][currentCB.data('operation')] = checkStyle;
                        }
                            // object level checkbox
                        else if (currentCB.data('parent') == "Object")
                        {
                            checkStyle = currentCB.data("indeterminate") == "True" ? "partial" : this.checked ? "checked" : "unchecked";
                            if (!(currentCB.data('module') + '/' + currentCB.data('object') in data.moduleStatus))
                            {
                                data.moduleStatus[currentCB.data('module') + '/' + currentCB.data('object')] = {};
                            }
                            data.moduleStatus[currentCB.data('module') + '/' + currentCB.data('object')][currentCB.data('operation')] = checkStyle;
                        }
                            // screen level checkbox
                        else
                        {
                            checkStyle = this.checked ? "checked" : "unchecked";
                            if (!(currentCB.data('modulePath') in data.moduleStatus))
                            {
                                data.moduleStatus[currentCB.data('modulePath')] = {};
                            }
                            data.moduleStatus[currentCB.data('modulePath')][currentCB.data('operation')] = checkStyle;
                        }
                    });

                    toggleViaAjax(cb, data, urlExtention);
                }
            };
        };

        //Bootstrap
        skyward.rolemodulepath.monitorDOM = skyward.rolemodulepath.monitorDOM || function ()
        {
            skyward.window.registerLoadDOMCallback(init);
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);